import { render, staticRenderFns } from "./BlockStyling.vue?vue&type=template&id=73902b11&scoped=true&"
import script from "./BlockStyling.vue?vue&type=script&lang=js&"
export * from "./BlockStyling.vue?vue&type=script&lang=js&"
import style0 from "./BlockStyling.vue?vue&type=style&index=0&id=73902b11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73902b11",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtnToggle,VCol,VContainer,VRow,VTextField})
